module.exports = "/images/aw.svg?2894a1329ea0c3c455023e833deb756d";